/**
 * Medidas do canvas usadas pelo layout automático (`elk-layout.ts`), pela
 * expansão de grupos e pelo contorno dos grupos. O fluxo corre da esquerda
 * para a direita: o gatilho fica à esquerda e os ramos se abrem na
 * vertical.
 */
import type { WorkflowNode } from '../types';

export const NODE_WIDTH = 220;
/** Altura de referência do card, quando ele ainda não foi medido. */
export const NODE_HEIGHT = 96;

/**
 * Espaço entre colunas. As portas de saída ficam FORA do card, à direita: a
 * pill nomeada mais larga ("Quando ocorrer") avança ~135px, e a curva da
 * aresta ainda precisa de respiro até o próximo card.
 */
export const RANK_SEP = 180;
/** Espaço entre cards empilhados na mesma coluna. */
export const NODE_SEP = 60;

export interface PositionedNode extends WorkflowNode {
  position: { x: number; y: number };
}

/**
 * Bounding box de um conjunto de nodes (pra desenhar containers de snippet).
 */
export function nodesBoundingBox(
  nodes: PositionedNode[],
  pad = 18,
): { x: number; y: number; width: number; height: number } | null {
  if (nodes.length === 0) return null;
  let xMin = Infinity;
  let yMin = Infinity;
  let xMax = -Infinity;
  let yMax = -Infinity;
  for (const n of nodes) {
    xMin = Math.min(xMin, n.position.x);
    yMin = Math.min(yMin, n.position.y);
    xMax = Math.max(xMax, n.position.x + NODE_WIDTH);
    yMax = Math.max(yMax, n.position.y + NODE_HEIGHT);
  }
  return {
    x: xMin - pad,
    y: yMin - pad,
    width: xMax - xMin + pad * 2,
    height: yMax - yMin + pad * 2,
  };
}
